module.exports = "/dist/ljs/vars-7942f06e70b89ccc9d287ef773bca098.js";